<template>
    <div class="background" :style="{'background': 'url(' + theImage + ')'}">
        <div class="transbox">
            <div class="transboxContent">
                <h2>{{ $t('terms.Header') }}</h2>

            </div>
        </div>
        <div id="image_holder" class="imageHolder">
            <div id="gridTerms">
                <div id="Hint" class="locationContent" style="text-align:end">{{ $t('terms.GridHint') }}</div>
                <kendo-datasource ref="datasourceTerms"
                                  :transport-read-url="url"
                                  :transport-read-data-type="'jsonp'">
                </kendo-datasource>
                <kendo-grid :data-source-ref="'datasourceTerms'"
                            ref="grid"
                            :sortable="true"
                            :toolbar="['pdf']"
                            :mobile="true"
                            :pdf-all-pages="true"
                            :pdf-avoid-links="true"
                            :pdf-paper-size="'A4'"
                            :pdf-margin="{ top: '2cm', left: '1cm', right: '1cm', bottom: '1cm' }"
                            :pdf-landscape="true"
                            :pdf-repeat-headers="true"
                            :pdf-file-name="$t('terms.PDFExportNameTerms')"
                            :pdf-title="$t('terms.PDFExportNameTerms')"
                            :pdf-scale="0.8">
                    <kendo-grid-column :field="'Koreanisch'"
                                       :title="$t('terms.GridColumnHeaderKorean')"
                                       :minResizableWidth="250">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'Deutsch'"
                                       :title="$t('terms.GridColumnHeaderGerman')"
                                       :minResizableWidth="250">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'Kategorie'"
                                       :title="$t('terms.GridColumnHeaderCategory')"
                                       :minResizableWidth="150">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'Soundlink'"
                                       :title="$t('terms.GridColumnHeaderSoundlink')"
                                       :template="urlColumnTemplate"
                                       :minResizableWidth="50">
                    </kendo-grid-column>
                </kendo-grid>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    import $ from 'jquery';
    import { EventBus } from '@/classes/eventBus.js';
    import '@progress/kendo-ui';
    import '@progress/kendo-theme-default/dist/all.css';
    import kendo from '@progress/kendo-ui';
    import { Grid, GridColumn } from '@progress/kendo-grid-vue-wrapper';
    import { KendoDataSource } from '@progress/kendo-datasource-vue-wrapper';
    import config from "@/appdata/config.json";

    export default {
        components: {
            'kendo-grid': Grid,
            'kendo-grid-column': GridColumn,
            'kendo-datasource': KendoDataSource,
        },
        props: {
            linkItem: String,
            myText: String,
            url: String
        },
        data: function () {
            return {
                theImage: '',
                schemaModelFields: {
                    Koreanisch: { validation: { required: true } },
                    Deutsch: { validation: { required: true } },
                    Kategorie: { validation: { required: true } },
                    Soundlink: { validation: { required: false } }
                }
            }
        },
        computed: {
        },
        mounted() {
            window.$ = kendo.jQuery;
            EventBus.$on('backgroundImageChange', image => {
                this.theImage = image;
            });
            const grid = this.$refs.grid.kendoWidget();
            $.each(grid.columns, function (index, column) {
                grid.resizeColumn(column, column.minResizableWidth);
            });
        },
        created() {
            this.url = config[0].ServiceUrl + config[0].ServiceUrlPort + "/WoerterbuchBegriffe"
        },
        methods: {
            urlColumnTemplate(e) {
                let urlSound = config[0].BaseUrl + "/Sounds/";
                if (e.Soundlink == null) {
                    return (
                        `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-volume-mute" viewBox="0 0 16 16">
                        <path d="M6.717 3.55A.5.5 0 0 1 7 4v8a.5.5 0 0 1-.812.39L3.825 10.5H1.5A.5.5 0 0 1 1 10V6a.5.5 0 0 1 .5-.5h2.325l2.363-1.89a.5.5 0 0 1 .529-.06zM6 5.04L4.312 6.39A.5.5 0 0 1 4 6.5H2v3h2a.5.5 0 0 1 .312.11L6 10.96V5.04zm7.854.606a.5.5 0 0 1 0 .708L12.207 8l1.647 1.646a.5.5 0 0 1-.708.708L11.5 8.707l-1.646 1.647a.5.5 0 0 1-.708-.708L10.793 8 9.146 6.354a.5.5 0 1 1 .708-.708L11.5 7.293l1.646-1.647a.5.5 0 0 1 .708 0z" />
                        </svg>`
                    );
                } else {
                    return (
                        `<a href="` + urlSound +
                        e.Soundlink +
                        `" target="_blank"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-volume-up" viewBox="0 0 16 16">
                      <path d="M11.536 14.01A8.473 8.473 0 0 0 14.026 8a8.473 8.473 0 0 0-2.49-6.01l-.708.707A7.476 7.476 0 0 1 13.025 8c0 2.071-.84 3.946-2.197 5.303l.708.707z"/>
                      <path d="M10.121 12.596A6.48 6.48 0 0 0 12.025 8a6.48 6.48 0 0 0-1.904-4.596l-.707.707A5.483 5.483 0 0 1 11.025 8a5.483 5.483 0 0 1-1.61 3.89l.706.706z"/>
                      <path d="M10.025 8a4.486 4.486 0 0 1-1.318 3.182L8 10.475A3.489 3.489 0 0 0 9.025 8c0-.966-.392-1.841-1.025-2.475l.707-.707A4.486 4.486 0 0 1 10.025 8zM7 4a.5.5 0 0 0-.812-.39L3.825 5.5H1.5A.5.5 0 0 0 1 6v4a.5.5 0 0 0 .5.5h2.325l2.363 1.89A.5.5 0 0 0 7 12V4zM4.312 6.39L6 5.04v5.92L4.312 9.61A.5.5 0 0 0 4 9.5H2v-3h2a.5.5 0 0 0 .312-.11z"/>
                    </svg>
                    </a>`
                    );
                }
            },
        }
    }
</script>

<style scoped>
    @import '../css/main.css';
</style>
